"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _material = require("@mui/material");
var _styles = require("@mui/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _getResource = require("../../utilities/getResource");
var _CustomMatrixQuestion = _interopRequireDefault(require("./CustomMatrixQuestion"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = function styles(theme) {
  return {
    radioButton: {
      display: 'flex',
      alignItems: 'center'
    },
    paperAnswer: {
      textAlign: 'center',
      backgroundColor: 'transparent',
      wordBreak: 'break-word',
      padding: '0 0.4em 0 0.4em'
    }
  };
};
var CustomMatrix = /*#__PURE__*/function (_Component) {
  function CustomMatrix(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, CustomMatrix);
    _this = _callSuper(this, CustomMatrix, [props]);
    (0, _defineProperty2["default"])(_this, "handleChange", function (question) {
      var questions = _this.state.questions.map(function (stateQuestion) {
        return stateQuestion.text === question.text ? _objectSpread(_objectSpread({}, stateQuestion), {}, {
          value: question.value
        }) : stateQuestion;
      });
      _this.setState({
        questions: questions
      });
      _this.props.onChange(questions);
    });
    _this.state = {
      questions: []
    };
    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(CustomMatrix, _Component);
  return (0, _createClass2["default"])(CustomMatrix, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        questions = _this$props.questions,
        value = _this$props.value,
        previousValue = _this$props.previousValue;
      if (questions.count === value.count) {
        questions.forEach(function (question, index) {
          question.value = value[index];
        });
      }
      if (questions.count === previousValue.count) {
        questions.forEach(function (question, index) {
          question.previousValue = previousValue[index];
        });
      }
      this.setState({
        questions: questions
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        answers = _this$props2.answers,
        classes = _this$props2.classes,
        questions = _this$props2.questions,
        resources = _this$props2.resources,
        language = _this$props2.language;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.radioButton
      }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        container: true
      }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        xs: 6
      }), answers.map(function (answer, index) {
        var answerText = '';
        if (language && answer.translations && answer.translations[language]) {
          answerText = answer.translations[language];
        } else {
          answerText = answer.label;
        }
        return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
          item: true,
          xs: true,
          container: true,
          justifyContent: "center",
          alignItems: "flex-end",
          key: index
        }, /*#__PURE__*/_react["default"].createElement(_material.Paper, {
          elevation: 0,
          className: classes.paperAnswer
        }, /*#__PURE__*/_react["default"].createElement(_material.Typography, null, answerText)));
      }), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        xs: true
      }), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/_react["default"].createElement(_material.Divider, null)), this.state.questions && this.state.questions.map(function (question, index) {
        return /*#__PURE__*/_react["default"].createElement(_CustomMatrixQuestion["default"], {
          question: question,
          answers: answers,
          resources: resources,
          language: language,
          onChange: _this2.handleChange,
          key: index
        });
      })));
    }
  }]);
}(_react.Component);
CustomMatrix.propTypes = {
  previousValue: _propTypes["default"].string,
  answers: _propTypes["default"].array
};
var _default = exports["default"] = (0, _styles.withStyles)(styles)(CustomMatrix);